"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * RichWise_Website_API.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfAddToCartRequest = instanceOfAddToCartRequest;
exports.AddToCartRequestFromJSON = AddToCartRequestFromJSON;
exports.AddToCartRequestFromJSONTyped = AddToCartRequestFromJSONTyped;
exports.AddToCartRequestToJSON = AddToCartRequestToJSON;
exports.AddToCartRequestToJSONTyped = AddToCartRequestToJSONTyped;
/**
 * Check if a given object implements the AddToCartRequest interface.
 */
function instanceOfAddToCartRequest(value) {
    return true;
}
function AddToCartRequestFromJSON(json) {
    return AddToCartRequestFromJSONTyped(json, false);
}
function AddToCartRequestFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'memberNo': json['memberNo'] == null ? undefined : json['memberNo'],
        'materialNo': json['materialNo'] == null ? undefined : json['materialNo'],
        'materialColorNo': json['materialColorNo'] == null ? undefined : json['materialColorNo'],
        'sizeSpecificationNo': json['sizeSpecificationNo'] == null ? undefined : json['sizeSpecificationNo'],
        'quantity': json['quantity'] == null ? undefined : json['quantity'],
        'promotionsDiscountNo': json['promotionsDiscountNo'] == null ? undefined : json['promotionsDiscountNo'],
    };
}
function AddToCartRequestToJSON(json) {
    return AddToCartRequestToJSONTyped(json, false);
}
function AddToCartRequestToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'memberNo': value['memberNo'],
        'materialNo': value['materialNo'],
        'materialColorNo': value['materialColorNo'],
        'sizeSpecificationNo': value['sizeSpecificationNo'],
        'quantity': value['quantity'],
        'promotionsDiscountNo': value['promotionsDiscountNo'],
    };
}
